import { APP_CONFIG } from '@/utils/constants'
import { STORE_KEY } from './constants'
import { mapState } from 'vuex';

export default {
	props: ['dataSource', 'nameField', 'location', 'parent', 'statusCorrect', 'questionSetVal', 'isDontShowResultSaved'],
	methods: {
        changeAnswer(evt, data) {
            // console.log('Change evt: ', evt, data)
            // let valueEmit = {...data, evt, position: data.location};
            // delete valueEmit.location;
            // this.$emit('changeAnswer', valueEmit)
            this.$emit('changeAnswer', evt, data);
        }
	}
}